import { type ButtonProps } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../shared/components/AppButton";
import styles from "./styles.module.css";

interface Props extends ButtonProps {
  message: string;
  folderName: string;
  isNameChanged?: boolean;
}

export const NoObjectChosen: FC<Props> = ({
  message,
  folderName,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles["no-dialog-chosen"]}>
      <div className={styles.message}>
        {message}
        <span className={styles["folder-name"]}>{folderName}</span>
      </div>
      <AppButton buttonType={"contained"} {...props}>
        {t("dialogs.create_object")}
      </AppButton>
    </div>
  );
};
